/**
 * Always returns "" — each page component handles isUmudugudu routing
 * by switching between /umudugudu/module-data/:module and the standard endpoint.
 */
export function getApiBase() {
  return "";
}

export function isMudugudUser() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return false;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return (payload.role || '').toLowerCase() === 'mudugudu';
  } catch {
    return false;
  }
}

/** Returns the logged-in user's role from JWT */
export function getUserRole() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return (payload.role || '').toLowerCase();
  } catch {
    return null;
  }
}
